import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Snackbar } from 'react-redux-snackbar';
import { Provider } from "react-redux";
import Store from "./Redux/Store";
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import 'react-infinite-calendar/styles.css';
ReactDOM.render(
    <Provider store={Store}>
        <div>
            <App />
            <Snackbar bodyStyle={{ backgroundColor: 'teal', color: 'coral' }}/>
        </div>
    </Provider>
    , document.getElementById('root'));